export default __webpack_public_path__ + "static/media/bbq_logo.d7c8a0c9.png";